module.exports = __webpack_public_path__ + "7a75ec7830241e1a0fdc00c975672c20.svg";